import { Breakpoint } from "@src/ruix/types";
import { useEffect, useRef, useState } from "react";

const useElementWidth = <T>(breakpoints: Breakpoint<T>[]) => {
	const [className, setClassName] = useState<T | "">("");
	const elementRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const updateWidth = () => {
			if (elementRef.current) {
				const width = elementRef.current.offsetWidth;
				const matchedBreakpoint =
					breakpoints.sort((a, b) => a.width - b.width).find((bp) => width < bp.width) ||
					breakpoints[breakpoints.length - 1];
				setClassName(matchedBreakpoint.className);
			}
		};

		updateWidth();

		window.addEventListener("resize", updateWidth);
		return () => window.removeEventListener("resize", updateWidth);
	}, [breakpoints]);

	return [className, elementRef] as const;
};

export default useElementWidth;
